module.exports = __webpack_public_path__ + "img/team4.8eaa45c4.jpg";